var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn btn-primary",class:{
          "btn-primary": !_vm.greyed,
          "btn-secondary": _vm.greyed,
        }},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.badge))])])
}
var staticRenderFns = []

export { render, staticRenderFns }